<template>
  <div class="page-outer">
    <browser-judge
      @close="handleBrowserJudgeClose"
      v-show="browserFlag"
    ></browser-judge>
    <div
      class="container login-page"
      :class="{ 'is-browser': browserFlag }"
    >
      <div
        class="m-notify-bar"
        v-if="isNotify && LicenseMsg.expireMsg"
      >
        <span v-html="LicenseMsg.expireMsg"></span>
        <i
          class="h-icon-close u-btn-close"
          @click="isNotify = false"
        ></i>
      </div>
      <banner-layout
        v-if="loginInfo && loginInfo.loginSchema === 'login-type1'"
        :info="loginInfo"
        @open-download="openDownload"
      >
        <login-form
          :panelColor="loginInfo.loginPanelColor"
          :language="language"
          :login-disabled="loginDisabled"
          v-show="hasLicense"
          :LicenseMsg="LicenseMsg"
          :service-url="serviceUrl"
        ></login-form>
        <language-select
          slot="lang-select"
          v-model="language"
          dark
        ></language-select>
      </banner-layout>
      <fullscreen-layout
        v-else
        :info="loginInfo"
        :isNotify="!!LicenseMsg.expireMsg"
        @open-download="openDownload"
      >
        <login-form
          :language="language"
          :panelColor="loginInfo.loginPanelColor"
          v-show="hasLicense"
          :login-disabled="loginDisabled"
          :LicenseMsg="LicenseMsg"
          :service-url="serviceUrl"
        ></login-form>
        <language-select
          slot="lang-select"
          :fontColor="downloadTextColor"
          v-model="language"
        ></language-select>
      </fullscreen-layout>
      <div class="icp">
        <a v-show="loginInfo.recordNumber" target="_blank"  :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+loginInfo.recordNumber">
          {{loginInfo.recordNumberStr}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import bannerLayout from './banner_layout'
import fullscreenLayout from './fullscreen-layout'
import languageSelect from './language-select.vue'
import loginForm from './login-form'
import Api from 'api/api'
import ApiConfig from 'api/config'
import browserJudge from 'components/browser-judge/browser-judge'
import { ErrorHandleMixin, LoadingMixin } from 'utils/mixin'
export default {
  name: 'login-page',
  data () {
    return {
      // 待license请求后再显示登录框
      hasLicense: false,
      loginInfo: {
        backgroundImg: '',
        backgroundImgInfo: {
          path: ''
        },
        downloadTextColor: '#fff',
        bgColor: '',
        identifyImgInfo:{
          path: ''
        },
        identifyType:'0',
        recordNumber:''
      },
      language: '',
      loginDisabled: false,
      serviceUrl: '',
      LicenseMsg: {
        allowLogin: true,
        expireDate: '2019-03-06T23:59:59+08:00',
        expireMsg: '',
        noLicense: false
      },
      isNotify: true,
      browserFlag: true,
      browserIconInfo: null,
      lpw:"",
    }
  },
  computed: {
    downloadTextColor () {
      return {
        'color': `${this.loginInfo.downloadTextColor || '#4d4d4d'}`
      }
    }
  },
  methods: {
    handleBrowserJudgeClose () {
      this.browserFlag = false
    },
    _isLogin () {
      Api.login.isLogin().then(res => {
        if (res.data) {
          location.href = location.origin
        }
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    _getLoginInfo () {
      let _loadingInstance = this._getLoading()
      Api.login
        .query()
        .then(res => {
          _loadingInstance.close()
          this.loginInfo = res.data
          // 防止没有设置登录页模式，给个默认值
          this.loginInfo.loginSchema = !this.loginInfo.loginSchema
            ? 'login-type1'
            : this.loginInfo.loginSchema
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    _getLicenseInfo () {
      Api.login
        .getLicenseInfo()
        .then(res => {
          this.LicenseMsg = res.data
          if (res.data) {
            this.hasLicense = true
          } else {
            this.hasLicense = false
          }
        })
    },
    getLoginInfo () {
      if (this.lpw) {
        this.loginInfo = this.$storage.get('login-info')
      } else {
        this._getLoginInfo()
      }
    },
    openDownload () {
      window.open(`${ApiConfig.context}/download/attachment`)
    }
  },
  mounted () {
    this.getLoginInfo()
    this.serviceUrl = window.location.href
  },
  mixins: [ErrorHandleMixin, LoadingMixin],
  components: {
    bannerLayout,
    fullscreenLayout,
    loginForm,
    languageSelect,
    browserJudge
  },
  created () {
    if (top !== window) {
      top.location.href = window.location.href
    }
    const search = window.location.search;
    this.lpw = /lpw\=true/.test(search)
    if (!this.lpw) {
      this._isLogin()
    }
    this._getLicenseInfo()
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.page-outer {
  position: relative;
  width: 100%;
  height: 100%;
  .login-page.container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    &.is-browser {
      top: 32px;
    }
    .m-notify-bar {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 32px;
      background: #ff952c;
      color: #fff;
      text-align: center;
      font-size: 12px;
      line-height: 32px;
      z-index: 1000;
      .u-btn-close {
        display: block;
        float: right;
        font-size: 16px;
        margin: 8px;
        cursor: pointer;
      }
      /deep/ a {
        color: #2196f3 !important;
        text-decoration: none !important;
      }
    }
  }
  .icp{
    height:30px;
    line-height:30px;
    text-align:center;
    a{
      text-decoration: none;
      color:#333333;
      font-size:14px;
    }

  }
}
</style>
